/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../utils/ObjectHelper'
], function(ObjectHelper) {

	const formatConstants = {
		// Default format constant from modelling
		FORMAT_DEFAULT_VALUE: 'FORMAT_DEFAULTVALUE',

		FORMAT_LENGTH_SHORT: 'short',
		FORMAT_FRACTION_DIGITS_ABBREV: 'abbrev',

		FORMAT_TYPES: {
			TEXT: 'text',
			NUMBER: 'number',
			PERCENT: 'percent',
			CURRENCY: 'currency',
			DATE: 'date',
			DATETIME: 'datetime'
		}
	};

	return ObjectHelper.deepFreezeObject(formatConstants);
});
